<div class="common-header-container {{ headerTitle | lowercase }}">
  <div class="common-header-left-child" [innerHTML]="headerTitle"></div>
  <button
    *ngIf="showAppUpdateInfoIcon"
    type="button"
    class="common-header-warning-btn"
    (click)="openAppUpdateNoticeFromHeader()"
    title="Update EasyEat Partner to version 2.9.8"
    aria-label="Update EasyEat Partner to version 2.9.8"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="#fff" stroke="none" aria-hidden="true">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
    </svg>
    <span class="warning-pulse"></span>
  </button>
  <button
    *ngIf="showSupportHoursInfoIcon"
    type="button"
    class="common-header-warning-btn"
    (click)="openSupportOperatingHoursNoticeFromHeader()"
    title="System Downtime for Maintenance"
    aria-label="System Downtime for Maintenance"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="#fff" stroke="none" aria-hidden="true">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
    </svg>
    <span class="warning-pulse"></span>
  </button>
  <div class="common-header-right-child">
    <div class="m-r-10">
      <printer-status-widget></printer-status-widget>
    </div>
    <div
    *ngIf="showScanQrAd"
    class="m-r-5"
    (click)="openScanQrAdModal()"
  >
    <img class="m-r-5" [src]="images.SCAN_QR_ICON" alt="Scan Icon" />
  </div>
  <button *ngIf="global_app_settings.enable_loan_feature && loanBtnData?.showBanner"
  class="logo-btn fw-600 fs-14"
  (click)="clickLoanComponent()"
  [disabled]="loanBtnData?.isSubmit && loanBtnData?.isFormSubmittedRecently"
>
  <img class="logo-img" [src]="images.FMH_LOAN_LOGO" alt="loan-logo" />
     {{loanButtonText}}
</button>
    <div
    *ngIf="isEEvalueVisible"
    class="ee-value-container m-r-5"
    (click)="openEEvalueModal()"
  >
    <!-- <img class="m-r-5" [src]="images.STAR_COIN" [alt]="'OPEN_CASH_DRAWER.STAR_COIN' | fallbackTranslate " /> -->
    <div>
      <div class="ee-total-earning">{{ Currency }} {{ eeTotalEarnings }}</div>
      <div class="ee-description">{{ 'OPEN_CASH_DRAWER.YESTERDAY_EXTRA_EARNING' | fallbackTranslate }}</div>
    </div>
  </div>
    <!-- <button (click)="openLhdnFormModal()" class="common-header-refer-btn" *ngIf="isMalaysia && !lhdnFormFilled">Refer Now</button> -->
    <img
      [src]="images?.DYNAMIC_QR_LOGO"
      alt="dynamic-qr-logo"
      (click)="getDineInFloors()"
      *ngIf="showDynamicQr && !isFoodCourt"
    />
    <img
      [src]="images?.CASH_DRAWER_LOGO"
      alt="cash-drawer-logo"
      (click)="openCashDrawer()"
      *ngIf="isCashDrawerVisible && !isMerge"
    />
    <button
      class="common-header-rc1 merge-btn"
      *ngIf="isMerge"
      (click)="openMergeDialog()"
    >
      + {{ 'SETTLE_BILL.MERGE_BILL' | fallbackTranslate }}
    </button>
    <button
      class="common-header-rc1 pos"
      *ngIf="isButton && !isMerge"
      (click)="openDialog()"
    >
      {{ headerButtonText }}
      <!-- &#65291;  ADD TABLE -->
    </button>
    <button *ngIf="isButton && !isMerge" class="pos-mobile-add" (click)="openMobDialog()">
      +
    </button>
  </div>
</div>
